export default state => state.similarItems.productId;
